import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { mbeConfigService } from './mbe-config.service';
import { Observable } from 'rxjs';
import {
  BasicResponse,
  SortFilterInterface,
} from '@auth-suite-services/services';
import {
  SasBfgInterfaceAPI,
  SasFinInterfaceAPI,
  SetupAccountServiceInterface,
  SetupAccountServiceInterfaceAPI,
} from '../..';

@Injectable({
  providedIn: 'root',
})
export class SetupAccountServiceService {
  private URL;
  headers: HttpHeaders;

  constructor(
    @Inject(mbeConfigService) private config,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl) => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  GetAllSetupAccountService(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    sortFilter?: SortFilterInterface | Record<string, unknown>
  ): Observable<SetupAccountServiceInterfaceAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;
    // Plain JSON body so flat fields like BFGDesc/FINNo/FINDesc post correctly 21/07/2026 DW
    const body =
      sortFilter && typeof sortFilter === 'object'
        ? JSON.parse(JSON.stringify(sortFilter))
        : {};
    return this.httpClient.post<SetupAccountServiceInterfaceAPI>(
      `${this.URL}/sas/getallsetupaccountservice/${pageIndex}/${pageSize}/${
        sortActive ? sortActive : 'id'
      }/${sort ? sort : 'asc'}`,
      body,
      { headers }
    );
  }

  GetSetupAccountService(id: number): Observable<SetupAccountServiceInterface> {
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<SetupAccountServiceInterface>(
      `${this.URL}/sas/getsetupaccountservice/${id}`,
      { headers }
    );
  }

  updateSAS(sas: SetupAccountServiceInterface) {
    console.log('Update SAS');
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/sas/updatesetupaccountservice`,
      sas,
      { headers }
    );
  }

  GetAllFIN(): Observable<SasFinInterfaceAPI> {
    const headers = this.headers;
    return this.httpClient.get<SasFinInterfaceAPI>(
      `${this.URL}/sas/getallfin`,
      { headers }
    );
  }

  GetAllBFG(): Observable<SasBfgInterfaceAPI> {
    const headers = this.headers;
    return this.httpClient.get<SasBfgInterfaceAPI>(
      `${this.URL}/sas/getallbfg`,
      { headers }
    );
  }

  // Added new method to create a new SAS. 03/10/2025 PK.
  createSetupAccountService(sas: SetupAccountServiceInterface): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(`${this.URL}/sas/createsetupaccountservice`, sas, { headers });
  }
}
